import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_DOMAIN}`;

const basicHeaders = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*"
};

export const get = (path, headers) => {
  console.log("API path", `${API_URL}${path}`);
  return axios.get(`${API_URL}${path}`, { headers: headers ? headers : basicHeaders, withCredentials: true });
};

export const post = (path, params, headers) => {
  console.log("API path", `${API_URL}${path}`);
  console.log("request params", params);
  return axios.post(
    `${API_URL}${path}`,
    {
      ...params
    },
    {
      headers: headers ? headers : basicHeaders,
      withCredentials: true
    }
  );
};
